export const projects = [
  {
    id: 1,
    titleKey: "elrawi",
    descKey: "p1_desc",
    tech: ["HTML", "CSS ", "BOOTSTRAB", "JAVASCRIPT"],
    image: "elrawi.png", // الصورة في فولدر public
    link: "https://elrawi.com" // لينك المشروع
  },
  {
    id: 2,
    titleKey: "elaraby",
    descKey: "p2_desc",
        tech: ["HTML", "CSS ", "BOOTSTRAB", "JAVASCRIPT"],

    image: "elaraby.png",
    link: "https://elaraby-design.com/"
  },
   {
    id: 3,
    titleKey: "zed",
        descKey: "p3_desc",

       tech: ["HTML", "CSS ", "BOOTSTRAB", "JAVASCRIPT"],

    image: "zed.png",
    link: "https://ziadhamada1.github.io/ZED/"
  },
    {
    id: 4,
    titleKey: "Brolos",
        descKey: "p4_desc",

      tech: ["HTML", "CSS ",  "JAVASCRIPT" , "LEFTJS"],

    image: "brolos.png", // الصورة في فولدر public
    link: "https://ziadhamada1.github.io/F-RS/" // لينك المشروع
  },
  {
    id: 5,
    titleKey: "calculoter",
      descKey: "p5_desc",
      tech: ["HTML", "CSS ", "BOOTSTRAB", "JAVASCRIPT"],

    image: "calculoter.png",
    link: "https://zed32910.github.io/calculator/"
  },
   {
    id: 6,
    titleKey: "Exzam",
       descKey: "p6_desc",

    tech: ["HTML", "CSS ", "BOOTSTRAB", "JAVASCRIPT"],

    image: "exzam.png",
    link: "https://ziadhamada1.github.io/ziiad/"
  },


{
  id: 7,
  titleKey: "inventory_system", // لازم يكون نفس الاسم اللي في ملف i18n
  descKey: "inventory_desc",    // لازم يكون نفس الاسم اللي في ملف i18n
  tech: ["HTML", "CSS", "BOOTSTRAP", "JAVASCRIPT"],
  image: "manegment.png",
  link: "https://zed32910.github.io/manegment/"
}


];